import { GetBalancesForAccountsURL, GetBalancesForWithdrawalURL, GetBalancesUrl } from '../constants';
export function GetAvailableFunds(api) {
    return (accountId, subaccountId) => {
        return api.authenticated().get(GetBalancesUrl, {
            accountId,
            subaccountId,
        }, {
            headers: { Accept: 'application/json' },
        });
    };
}
export function GetBalances(api) {
    return (accountId, subaccountId) => {
        return api.authenticated().get(GetBalancesUrl, {
            accountId,
            subaccountId,
        }, {
            headers: { Accept: 'application/json' },
        });
    };
}
export function GetBalancesForAccounts(api) {
    return (items) => {
        return api.authenticated().post(GetBalancesForAccountsURL, {
            items,
        }, {
            headers: { Accept: 'application/json' },
        });
    };
}
export function GetBalancesForWithdrawal(api) {
    return (accountId) => {
        return api.authenticated().get(GetBalancesForWithdrawalURL(accountId), {}, {
            headers: { Accept: 'application/json' },
        });
    };
}
//# sourceMappingURL=getBalances.js.map